"use client";

import { useEffect, useState } from "react";
import { canShareImageFile, fetchShareImageFile, getBlogSocialImagePath } from "@/lib/blogShare";

// The blog's own image as a File, ready for navigator.share({ files }), or null.
// Null - so callers hide the "share with image" option - whenever the blog has
// no image of its own, the image cannot be fetched, or this browser's share
// sheet cannot accept an image file (canShare). Fetched ahead of the click so
// the click handler can call navigator.share() while the user gesture is valid.
export default function useShareImageFile(blog) {
  const path = getBlogSocialImagePath(blog);
  const title = blog?.title;
  const [ready, setReady] = useState({ path: "", file: null });

  useEffect(() => {
    if (!path || typeof navigator === "undefined" || typeof navigator.canShare !== "function") return undefined;
    let active = true;
    fetchShareImageFile(path, title)
      .then((file) => {
        if (active && canShareImageFile(file)) setReady({ path, file });
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [path, title]);

  return ready.path === path ? ready.file : null;
}
